import { SortOrders } from "src/app/shared/models/sort-orders";

export class CandidatesFilter {
    constructor() {
        this.pageNumber = 1;
    }

    keyword: string;
    location: string;
    datePostedPeriod: number|null;
    sectors: string[] = [];
    experience: number|null;
    salaryTypeId: string;
    minimumSalary: number|null;
    maximumSalary: number|null;
    qualifications: string[] = [];
    sortBy: SortOrders;
    pageNumber: number;
}